import CloseIcon from "@mui/icons-material/Close"
import { Box, Button, IconButton, Modal } from "@mui/material"
import styles from "./Owners.module.css"
import { ReactNode, memo } from "react"

interface TOwnersActionProps {
  open: boolean
  onClose?: () => void
  title: string
  desc: string | ReactNode
  ownerId: string
  submit?: {
    onSubmit: (ownerId: string) => void
    label: string
  }
  cancel?: {
    onCancel: () => void
    label: string
  }
}

const OwnersActionModal = ({ open, onClose, title, desc, ownerId, submit, cancel }: TOwnersActionProps) => {
  const onCloseModal = () => {
    if (typeof onClose === "function") {
      onClose()
    }
  }

  return (
    <Modal
      open={open} //
      onClose={onCloseModal}
      aria-labelledby="owner-action-modal-title"
      aria-describedby="owner-action-modal-description"
      className={styles.ActionModalRoot}
    >
      <Box className={styles.ActionContent}>
        <Box className={styles.ActionHeader}>
          <Box className={styles.ActionTitle}>{title}</Box>
          <IconButton className={styles.CloseIcon} onClick={onCloseModal}>
            <CloseIcon sx={{ color: "white", fontSize: 20 }} />
          </IconButton>
        </Box>
        <Box className={styles.ActionDesc}>{desc}</Box>
        <Box className={styles.ActionFooter}>
          {cancel && (
            <Button className={styles.ActionCancelButton} variant="outlined" color="success" onClick={cancel.onCancel}>
              {cancel.label}
            </Button>
          )}
          {submit && (
            <Button className={styles.ActionSubmitButton} variant="contained" onClick={() => submit.onSubmit(ownerId)}>
              {submit.label}
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  )
}

export default memo(OwnersActionModal)
